// apps/client/src/net/socket.ts
export const clientNetSocketConfig = {
  MAX_QUEUE: 512 as const,
  // Reattach ladder: retry promptly to preserve the reserved seat.
  // The last rung is reused for every later attempt, so the
  // per-step wait stays capped at 2000 ms.
  DEFAULT_DELAYS: [250, 500, 1000, 2000],
  // Silent-OPEN watchdog: three heartbeat intervals, well below the 90 s
  // server seat grace period so a blackholed client reattaches with its seat
  // kept, far above healthy traffic gaps (views every ~33 ms while running,
  // `alive` every 5 s otherwise — including hidden tabs, whose timers fire at
  // ~1 s granularity while inbound WebSocket delivery is not throttled).
  SOCKET_WATCHDOG_MS: 15000 as const,
};

// apps/client/src/ui/owners.ts
export const clientNetOwnerNamesConfig = {
  OWNER_NAMES: ["Blue", "Red", "Gold", "Purple", "Green", "Aqua", "Pink", "Mint"],
};

// apps/client/src/net/session.ts
export const clientNetSessionConfig = {
  WELCOME_TIMEOUT_MS: 10000 as const,
  LEAVE_FLUSH_MS: 750 as const,
  // A malformed server message replaces the socket for a fresh welcome and
  // full view. The match freezes only after this many replacements inside
  // MALFORMED_WINDOW_MS, so a server that keeps sending bad data cannot
  // loop reconnects forever.
  MALFORMED_RECOVERIES: 3 as const,
  MALFORMED_WINDOW_MS: 60_000 as const,
};

// apps/client/src/net/presentation.ts
export const clientNetPresentationConfig = {
  // Smallest interpolation buffer: the render clock trails the newest view by
  // this much, so a shorter buffer shows a click reaction sooner.
  // Calibration knob, provisional pending browser measurements.
  NET_INTERP_MS: 50,
  // The buffer grows to cover late or paced views (the server spaces views up
  // to VIEW_PACE_MAX_GAP_MS for a slow socket). Calibration knobs: the largest
  // buffer, the render clock rate while it is behind, and the lag past which
  // the clock jumps.
  NET_INTERP_MAX_MS: 500 as const,
  NET_CATCHUP_RATE: 1.25 as const,
  // Render clock rate while it is ahead of the buffer (the buffer just grew):
  // it slows instead of stopping, so a late view never freezes the picture.
  NET_SLOWDOWN_RATE: 0.8 as const,
  NET_SNAP_MS: 1000 as const,
  // Bounded received-sample ring. At the 30 Hz publication cadence (plus
  // off-cadence intent flushes) this holds a little over two seconds of
  // history.
  NET_MAX_SAMPLES: 64 as const,
  // A gap this far past the interpolation window marks the stream as starved:
  // the latest pose stays frozen and the frame loop shows connection status.
  // Provisional pending measurement.
  NET_STARVE_MS: 500 as const,
};

export const networkClientConfig = { latencyAlpha: 0.3, versionPollMs: 5 * 60 * 1000 };

export const networkPauseConfig = {
  resumeCountdown: 3,
  countdownStepMs: 1000,
};
